import setupAxios from "../../lib/redux/setupAxios"

export const getAllDeviceHighScoreList = async (queryParams)=>{
    return setupAxios
    .get('/devices_high_scoring/get_records', {
        params: queryParams,
    })
    .then((res) => res?.data?.data)
}